export default __webpack_public_path__ + "static/media/№ KZ.M.07.2175.366cc77c.svg";